import { Component, OnInit } from '@angular/core';

import { HotelService } from '../services/hotel.service';
import { Hotel } from '../hotel';

import { MessageService } from '../services/message.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent implements OnInit {

  model = new Hotel;


  constructor(private hotelService: HotelService, private messageService: MessageService) { }
  profiles: any; rates: any;
  public now: Date = new Date();
  ngOnInit() {
    //this.getHotelRates()
    this.getHotel();
    this.allHotels();
    this.getUnits();
    setInterval(() => {
      this.now = new Date();
    }, 1);



  }

  getHotel() {
    this.hotelService
      .getAllHotel()
      .subscribe(profiles => {
        this.profiles = profiles;
        // console.log(this.profiles);
      })
  }

  addHotelMaterial() {

    this.hotelService
      .addHotelMaterial(this.model)
      .subscribe(response => {
        //console.log(response);
        this.getHotel();
        $('#myform').trigger("reset");
        $("html, body").animate({ scrollTop: 0 }, "slow");

        this.messageService.showMessage('div#msg', 'alert-info', response.response, 'glyphicon-ok')
      })
  }

  addHotel() {

    this.hotelService
      .addHotel(this.model)
      .subscribe(response => {
        // console.log(response);
        $("#myModal .close").click();
        this.getHotel();
        this.messageService.showMessage('div#msg', 'alert-info', response.response, 'glyphicon-ok')
      })
  }

profiles1: any;
  allHotels(){
    this.hotelService
      .allHotels(this.model)
      .subscribe(profiles1 => {
        this.profiles1 = profiles1;
        // console.log(this.profiles1);
        
      })
  }

onChange(val) {
  this.obj = { "hotelid": val };
  this.hotelService
    .editHotel(this.obj)
    .subscribe(response => {
      this.model = response;
      // console.log(this.model)

    })
}

  obj: any;
  editrate() {
    this.obj = { "hotelid": this.model.hotelid };
    //console.log(this.obj);
    this.hotelService
      .assignRate(this.obj)
      .subscribe(rates => {
        this.rates = rates[0];
        //console.log(rates[0]);
        Object.assign(this.model, this.rates);

      })
  }

  

  editHotelMaterial() {
    console.log(this.model);

    this.hotelService
      .editHotelMaterial(this.model)
      .subscribe(response => {
        //console.log(response);
        this.getHotel();
        $('#myform').trigger("reset");
        $("html, body").animate({ scrollTop: 0 }, "slow");

        this.messageService.showMessage('div#msg', 'alert-info', response.response, 'glyphicon-ok')
      })
  }

  updateHotel() {
    //console.log(this.obj);
    this.hotelService
        .updateHotel(this.model)
        .subscribe( response => {
        // this.getHotel();
        this.messageService.showMessage('div#msg', 'alert-info', response.response, 'glyphicon-ok');
        $("#myModal1 .close").click();
        })
  }

  deleteHotel() {
    //console.log(this.obj);
    this.hotelService
        .deleteHotel(this.model)
        .subscribe( response => {
        // this.getHotel();
        this.messageService.showMessage('div#msg', 'alert-info', response.response, 'glyphicon-ok');
        $("#myModal1 .close").click();
        })
  }

  units: any;
  getUnits(){
    this.hotelService
      .getUnits({})
      .subscribe(profiles => {
        this.units = profiles;
        // console.log(this.profiles);
      })
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/home/home.component.ts